import { render, staticRenderFns } from "./MyProjectsButtonArea.vue?vue&type=template&id=5272c308&scoped=true"
import script from "./MyProjectsButtonArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectsButtonArea.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyProjectsButtonArea.vue?vue&type=style&index=0&id=5272c308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5272c308",
  null
  
)

export default component.exports